import React, {
  cloneElement,
  useMemo,
  useRef,
} from 'react';


const InputFile = (props) => {
  const {
    className,
    id,
    name,
    accept,
    multiple = false,
    disabled = false,
    children,
    onChange,
  } = props;

  const inputRef = useRef(null);

  const child = useMemo(() => {
    const element = React.Children.only(children);
    const mergedProps = {
      onClick: async (event) => {
        if (disabled) return;

        // 触发元素自身的 click 事件
        const childOnClick = (children)?.props?.onClick;
        const ok = await childOnClick?.(event);

        if (typeof ok === 'undefined' || (typeof ok === 'boolean' && ok)) {
          inputRef.current?.click();
        }
      },
    };

    return cloneElement(element, mergedProps);
  }, [children]);

  return (
    <div className={className}>
      <input
        ref={inputRef}
        id={id}
        name={name}
        type="file"
        accept={accept}
        multiple={multiple}
        className="hidden"
        onChange={event => {
          onChange?.(event)
          setTimeout(() => {
            inputRef.current.value = ''
          }, 1500)
        }}
      />
      {child}
    </div>
  );
};

export default InputFile;
